import React, { useRef } from 'react';
import SearchInput from '../../SearchInput';
import styles from './SchemaEntitiesSearch.module.scss';
import { HighlightedSearchContext } from '../../../context';
import { useSearchTerm } from '../../../hooks';

const usePreserveScroll = () => {
  const scrollPositionRef = useRef(0);

  return (e: React.UIEvent<HTMLDivElement>) => {
    //
    // SchemaNav is wrapped in <Resizable> which sets scrollTop to 0 whenever resizing.
    //   We don't want that to happen (as loses scroll position) so when it does, we reset it back to its previous position.
    //
    if (e.currentTarget.scrollTop === 0 && scrollPositionRef.current > 200) {
      // reset back to previous position
      e.currentTarget.scrollTop = scrollPositionRef.current;
    } else {
      // store current position
      scrollPositionRef.current = e.currentTarget.scrollTop;
    }
  };
};

export type SchemaEntitiesSearchProps = {
  openConfigureTableModalButton: Nullable<JSX.Element>;
  openConfigureJoinsModalButton: Nullable<JSX.Element>;
};

export const SchemaEntitiesSearch: React.FC<SchemaEntitiesSearchProps> = ({
  children,
  openConfigureTableModalButton,
  openConfigureJoinsModalButton,
}) => {
  const handleScroll = usePreserveScroll();
  const [search, handleSearch] = useSearchTerm();

  return (
    <div className={styles.schemaContainerInner}>
      <div className={styles.headerContainer}>
        <div className={styles.headerLocal}>
          <h4>Database map</h4>
        </div>
        <div className={styles.buttonsContainer}>
          {openConfigureTableModalButton}
          {openConfigureJoinsModalButton}
        </div>
        <SearchInput
          value={search}
          onSearch={handleSearch}
          placeholder="Search tables and columns"
        />
      </div>
      <div className={styles.schemaContainer} onScroll={handleScroll}>
        <HighlightedSearchContext.Provider value={search}>
          {children}
        </HighlightedSearchContext.Provider>
      </div>
    </div>
  );
};
